module.exports = __webpack_public_path__ + "static/media/tax-refunds.348abeef.svg";